// import { UsersTopBar } from 'features/users/components/top-bar/users-top-bar';
// import { UsersTable } from 'features/users/components/users/users-table';
// import {
//   UserFilterFormValues,
//   UserFilterFormValuesPaginated,
// } from 'features/users/components/users-filter-form/types';
// import {
//   // allAvailableRolesExceptUser,
//   allAvailableRolesForLoggedInUser,
//   USER_ROLES,
// } from 'features/users/permissions';
// import { useGetUsersList } from 'features/users/use-cases/get-users';
// import { useUserContext } from 'features/users/user-context';
import { AgentTable } from 'features/agent/compoenents/table/AgentTable';
import { AgentFilterFormValues, AgentFilterFormValuesPaginated } from 'features/agent/compoenents/top-bar/agent-filter-form';
import { AgentTopBar } from 'features/agent/compoenents/top-bar/agent-top-bar';
// import { User } from 'types';
import { useGetAgentList } from 'features/agent/use-cases/get-agent-list';
import { usePaginationParams } from 'hooks';
// import { omit } from 'lodash';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const getInitialFilterValues: AgentFilterFormValues = {
  FullName: undefined,
  UserId: undefined,
  LogType: undefined,
};


export const AgentView = () => {

  const [adminUserEditData, setAdminUserEditData] = useState<any>(undefined);
  const { params, updateParams, resetPage } =
    usePaginationParams<AgentFilterFormValuesPaginated>({
      page: 1,
      size: 10, 
      order_by: 'name',
      ...getInitialFilterValues,
    });

  const getUsersListQueryResponse = useGetAgentList((params),{
      retry: false,
    },
  );

  
  const handleFiltersChange = (values: AgentFilterFormValues) => {

    updateParams(values);
    resetPage(); 
  };



  return (
    <>
      <AgentTopBar
        handleFilter={handleFiltersChange}
        getInitialFilterValues={getInitialFilterValues}
        adminUserEditData={adminUserEditData}
      />
      <AgentTable
        isUsersListLoading={
          getUsersListQueryResponse.isLoading &&
          getUsersListQueryResponse.isFetching
        }
        usersList={getUsersListQueryResponse?.data?.items}
        itemsCount={getUsersListQueryResponse.data?.total || 0}
        tableParams={params}
        updateParams={updateParams}
        adminUserEditData={adminUserEditData}
        setAdminUserEditData={setAdminUserEditData}
      />
      <Outlet />
    </>
  );
};
